import configureStore from './configureStore';

const store = configureStore(process.env.REACT_APP_STAGE === 'production');

export default store;

